/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import { Request } from 'fetchboi'

export const getActivities = Request.register({
  endpoint: '/activities?CongressSlug=:CongressSlug',
  method: 'get'
})

export const getActivitiy = Request.register({
  endpoint: '/activities/:id',
  method: 'get'
})

export const checkActivityAvailability = Request.register({
  endpoint: '/registrations/activities/checkAvailability?ActivityID=:id&timestamp=:timestamp',
  method: 'get'
})

export const saveActivities = Request.register({
  endpoint: '/registrations/activities/batch',
  method: 'post',
})

export const updateActivities = Request.register({
  endpoint: '/registrations/activities/batch',
  method: 'put',
})

export const getInscriptionActivities = Request.register({
  endpoint: '/registrations/activities?RegistrationUUID=:id',
  method: 'get'
})

export const getSubActivities = Request.register({
  endpoint: '/subActivities?ActivityID=:activityId',
  method: 'get',
  useAuthentication: true,
})

export const getActivitySpeakers = Request.register({
  endpoint: '/activitySpeakers?ActivityID=:activityId&include=Speaker',
  method: 'get',
  useAuthentication: true,
})
